/* global I18N */

import { Controller } from 'stimulus';
import { prettyPrice } from '../helpers/cartHelpers';

class CartSummaryController extends Controller {
  connect() {
    this.subTotal = parseFloat(this.data.get('sub-total'));
    this.shippingCosts = parseFloat(this.data.get('shipping-costs'));
  }

  setShippingCosts(price) {
    this.shippingCosts = price;
    this.recalculate();
  }

  recalculate() {
    this.total = this.subTotal + this.shippingCosts;

    this.totalTarget.innerHTML = prettyPrice(this.total);
    this.shippingCostsTarget.innerHTML = this.shippingCosts
      ? prettyPrice(this.shippingCosts)
      : I18N.shipping_costs_free;
  }
}

CartSummaryController.targets = [
  'shippingCosts',
  'total',
];

export default CartSummaryController;
